import { FC, useEffect, useState } from "react";
import FlexBox from "../../../FlexBox";
import { List, styled, Theme, useMediaQuery } from "@mui/material";
import MenuList, { IMenuItem, AdminMenuList } from "../../MenuList";
import { IsGranted } from "../../../../guards/IsGranted";
import { SideBarHeader } from "./SideBarHeader";
import { MenuItem } from "./MenuItem";
import { styles } from "../styles";
import useAuth from "../../../../hooks/useAuth";
import { USER_TYPES } from "../../../../constants/user-types";

const ContentWrapper = styled(FlexBox)(() => ({
  width: "100%",
  height: "100%",
  padding: "10px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
}));

interface ISideBarContent {
  closeMobileSideBar?: (value: boolean) => void;
}

const SideBarContent: FC<ISideBarContent> = ({ closeMobileSideBar }) => {
  const { user }: any = useAuth();
  const [openCollapse, setOpenCollapse] = useState("");
  const [menu, setMenu] = useState<any>([]);
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  useEffect(() => {
    if (user?.type) {
      if (user?.type == USER_TYPES.SYSTEM_ADMIN) {
        setMenu(AdminMenuList);
      } else {
        setMenu(MenuList);
      }
    }
  }, [user]);

  return (
    <ContentWrapper>
      <>
        {downMd && <SideBarHeader />}
        <List sx={{ ...styles.menuListContainer, mt: { xs: 0, md: 8 } }}>
          {menu.map((item: IMenuItem, index: number) => (
            <IsGranted
              key={`${item.title}-main-${index}`}
              permissions={item.permissions || []}
            >
              <MenuItem
                item={item}
                openMenu={openCollapse}
                setOpen={setOpenCollapse}
                closeMobileSideBar={closeMobileSideBar}
              />
            </IsGranted>
          ))}
        </List>
      </>
    </ContentWrapper>
  );
};

export default SideBarContent;
